import Vue from 'vue';
import moment from 'moment';
moment.locale('es');

Vue.filter('capitalize', val => `${val.slice(0, 1).toUpperCase()}${val.slice(1)}`);

Vue.filter('uppercase', val => val ? val.toUpperCase() : '');

Vue.filter('trim', val => val ? val.substring(0, 20) + '. . .' : '');

Vue.filter('formatDate', date => {
    return moment(date).format('DD / MM / YYYY')
})
Vue.filter('formatDateTime', date => {
    return moment(date).format('DD/MM/YYYY hh:mm A')
})

Vue.filter('formatAmount', (number, currency) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(number);
});

Vue.filter('formatBytes', (bytes) => {
    if (bytes < 1000) {
        return bytes + " B";
    }
    let nbytes = bytes;
    let ciIndex = -1;
    const ci = "kMGTPE";
    while (nbytes >= 1000) {
        nbytes /= 1000;
        ciIndex++;
    }
    return `${nbytes.toFixed(2)} ${ci[ciIndex]}`;
});

Vue.filter('colorProcedureStatus', (status) => {
    const lowerStatus = status.toLowerCase();
    switch (lowerStatus) {
        case 'entregado':
        case 'rev administrativa':
            return 'green';
        case 'anulado':
        case 'retirado':
        case 'renunciado':
            return 'red';
        case 'en curso':
        case 'impreso':
        case 'bloqueado':
            return 'orange';
        case 'pte de pago':
        case 'pte impresión':
        case 'pte examen visual':
        case 'pte examen auditivo':
        case 'pendiente de pago':
            return 'blue';
        default:
        return null;
    }
});

Vue.filter('colorPaymentStatus', (status) => {
    const lowerStatus = status.toLowerCase();
    switch (lowerStatus) {
        case 'aprobado':
            return 'green';
        case 'denegado':
        case 'error':
            return 'red';
        case 'retener':
            return 'orange'; 
        case 'enviado':
            return 'blue';
        default:
        return null;
    }
});


Vue.filter('colorDocumentStatus', (status) => {
    switch (status) {
        case 'APROBADO':
        case 'OK':
            return 'green';
        case 'NOK':
        case 'RECHAZADO':
        case 'DEL':
        case 'ELIMINADO':
            return 'red';
        case 'PEN':
        case 'EN REVISIÓN':
            return 'orange';
        case 'ENVIADO':
        case 'NEW':
            return 'blue';
        default:
        return null;
    }
});